import {JSONItemBase} from "PDFLib/core/writers/JSONWriter/JSONItem/JSONItemBase";
import {FontItem} from "PDFLib/core/writers/JSONWriter/FontItem";

export class JSONObject{
    public Items:JSONItemBase[];
    public Fonts:any[];

    constructor() {
        this.Items=[];
        this.Fonts=[];
    }

    public AddItem(item:JSONItemBase)
    {
        this.Items.push(item);
    }

    public AddFont(font:any)
    {
        this.Fonts.push(font);
    }

}